import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { LAB_TEST_REFERENCE_VALUES, isAbnormalResult } from "../../../../utils/constants/labTestReferenceValues";

const fields = [
  { key: "sugarF", label: "Sugar (F)", unit: "mg/dL" },
  { key: "sugarPP", label: "Sugar (PP)", unit: "mg/dL" },
  { key: "sugarR", label: "Sugar (R)", unit: "mg/dL" },
  { key: "screatinine", label: "S. Creatinine", unit: "mg/dL" },
  { key: "urea", label: "Urea", unit: "mg/dL" },
  { key: "uricAcid", label: "Uric Acid", unit: "mg/dL" },
  { key: "calcium", label: "Calcium", unit: "mg/dL" },
  { key: "amylase", label: "Amylase", unit: "U/L" },
];

export default function BioChemistryTestReport({ defaultValues, gender, reportTemplate }) {
  if (!defaultValues || Object.keys(defaultValues).length === 0) {
    return <p>डाटा उपलब्ध छैन</p>;
  }
  return (
    <TableContainer>
      <Table classes={{ root: "table-bordered" }} size="small" aria-label="Biochemistry Test">
        <TableHead classes={{ root: "align-center" }}>
          <TableRow>
            <TableCell>Test</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Reference Value</TableCell>
            <TableCell>Unit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody classes={{ root: "align-center" }}>
          {fields.map(({ key, label, unit }) => (
            defaultValues[key] ? (
              <TableRow key={key}>
                <TableCell>{label}</TableCell>
                <TableCell style={isAbnormalResult(key, defaultValues[key], reportTemplate, gender) ? { fontWeight: "bold" } : {}}>
                  {defaultValues[key]}
                </TableCell>
                <TableCell>{LAB_TEST_REFERENCE_VALUES[reportTemplate]?.[key]?.reference || "-"}</TableCell>
                <TableCell>{unit}</TableCell>
              </TableRow>
            ) : null
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
